import { Box, TextareaAutosize } from '@mui/material';
import styled, { createGlobalStyle } from 'styled-components';
import { colorTheme } from './muiTheme';

export const StyleCommentchat = createGlobalStyle`

.tri-right.left-top:after {
    content: ' ';
    position: absolute;
    width: 0;
    height: 0;
    left: -12px;
    right: auto;
    top: 0px;
    bottom: auto;
    border: 18px solid;
    border-color: ${colorTheme.palette.secondary.light} transparent transparent transparent;
  }
  .tri-right.right-top:after {
    content: ' ';
    position: absolute;
    width: 0;
    height: 0;
    left: auto;
    right: -12px;;
    top: 0px;
    bottom: auto;
    border: 18px solid;
    border-color: ${colorTheme.palette.primary.light}  transparent transparent transparent;
  }
  .main-chat-wrapper-talking {
    display: flex;
    justify-content: left;
    margin-left: 20px;
  }
  .main-chat-wrapper-reply {
    display: flex;
    justify-content: end;
    margin-right: 20px;
  }
  .talk-bubble {
    display: inline-block;
    position: relative;
    background: ${colorTheme.palette.secondary.light}  0% 0% no-repeat padding-box;
    border-radius: 8px;
    opacity: 1;
    display: block;
    max-width: 100%;
    min-height: 54px;
    text-align: left;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0px;
    color: ${colorTheme.palette.common.black} ;
    opacity: 1;
    padding: 13px;
    margin-right:10px;
    margin-bottom: 15px;
  }
  .reply-bubble {
   
    display: inline-block;
    position: relative;
    background: ${colorTheme.palette.primary.light}  0% 0% no-repeat padding-box;
    border-radius: 8px;
    opacity: 1;
    display: block;
    max-width: 100%;
    min-height: 54px;
    text-align: left;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0px;
    color: ${colorTheme.palette.common.white} ;
    opacity: 1;
   padding:12px;
   margin-bottom:15px;
  }
  .day-separator {
    font: normal normal 600 12px/17px Open Sans;
    letter-spacing: 0px;
    color: ${colorTheme.palette.common.black} ;
    display: flex;
    justify-content: center;
    padding: 20px;
  }
   
  .chat-small-label {
    text-align: right;
    font: normal normal 600 12px/17px Open Sans;
    letter-spacing: 0px;
    color: ${colorTheme.palette.common.black};
    display: block;
  }
  `;

export const StyledChatMessage = styled(Box) <{ bgColor: string }>`
  background: ${({ bgColor }) => bgColor} !important;

    &:after {
      content: ' ';
      position: absolute;
      width: 0;
      height: 0;
      left: auto;
      right: -12px;
      top: 0px;
      bottom: auto;
      border: 18px solid;
      border-color: ${({ bgColor }) => bgColor} transparent transparent transparent !important;
    }
`;

export const StyledChatInput = styled(TextareaAutosize)`
  outline: none;
  width: 100%;
  padding: 7px;
  font-size: 14px;
  resize: none;
  font-family: Open Sans;
  overflow-y: auto important;
  border: 1px solid ${colorTheme.palette.secondary.main};
  border-radius: 6px;
`;
